import {useContext} from "react";
import CreateQRCodeContext from "../../../CreateQRCodeContext";
import Form from "../../../_utils/forms/Form";
import FormField from "../../../../../_utils/forms/field/FormField";
import {IconNetwork} from "@tabler/icons-react";

/**
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function WebsiteForm() {
    /**
     * CreateQRCodeContext
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(CreateQRCodeContext);

    /**
     * On URL change.
     * @author Kacper Faber
     * @since 0.1.8
     * @param ev
     */
    const onUrlChange = (ev: any) => {
        ctx.setPayload({ ...ctx.payload, websiteUrl: ev.target.value })
    }

    return (
        <Form label="Adres URL" icon={<IconNetwork size={32}/>}>
            <FormField
                label="Adres URL"
                onChange={onUrlChange}
            />
        </Form>
    );
}

export default WebsiteForm;